import {
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { websiteActionEndPointLogic } from "../../../../../../logic/AssetManagement/Websites/websiteActionEndPointLogic";
import {
  selectIsLoading,
  selectUserData,
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../../../features/userSlice";
import store from "../../../../../../store";
import { useSelector } from "react-redux";
import SimpleBackdrop from "../../../../../BackDrop/BackDrop";
import { CheckPermissions } from "../../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

interface DeactivateWebsiteModalProps {
  open: boolean;
  handleClose: () => void;
  isActive: any;
  websiteShareUid: any;
  oauthTokenHeader: any;
  refreshWebsites: any;
  website_name: any;
}

function DeORReactivateWebsiteModal({
  open,
  handleClose,
  isActive,
  websiteShareUid,
  oauthTokenHeader,
  refreshWebsites,
  website_name,
}: DeactivateWebsiteModalProps) {
  const [siteName, setSiteName] = useState("");
  const response = useSelector(selectUserData);
  const [isDeactivate, setisDeactivate] = useState(false); //--- Checkbox
  const isLoading = useSelector(selectIsLoading);
  const hasToggleWebsiteStatusPermission = CheckPermissions(
    response?.data?.products?.assets,
    "websites",
    "toggle_website_status",
  );
  //-- Reset Website name and unchecked checkbox when closing the modal
  useEffect(() => {
    setSiteName("");
    setisDeactivate(false);
  }, [handleClose]);

  //-- When click on Deactivate or Reactivate button
  const deactiveOrActiveWebsite = async () => {
    const data = {};
    try {
      store.dispatch(setIsLoading(true));
      const response =
        await websiteActionEndPointLogic.deactiveOrReactivateWebsite(
          data,
          websiteShareUid,
          oauthTokenHeader,
        );
      if (response?.status === 200 || response?.status === 204) {
        store.dispatch(
          setDisplayErrorSnackBar({
            message: `The website has been successfully ${isActive === 1 ? "deactivated" : "activated"}.`,
            type: "success",
          }),
        );
        //-- Refresh Parent Data(Website List Data) After Success
        await refreshWebsites();
        handleClose();
      }
    } catch (error: any) {
      console.error("Error Update the Activate or Deactivate Data", error);
    } finally {
      store.dispatch(setIsLoading(false));
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            {isActive === 1 ? "Deactivate" : "Reactive"} Website
          </DialogTitle>
          {isLoading && <SimpleBackdrop />}
          <Box>
            {isActive === 1 ? (
              <Typography>
                Are you sure you want to deactivate this website?
                <br />
                Deactivating the website will make it inaccessible to all users
                and will cause the need for further actions such as pausing any
                active campaign or service associated with it. This action can
                be reversed from the edit account screen.
                <br />
                <Box
                  component="span"
                  sx={{ display: "block", fontWeight: 500, marginTop: "8px" }}
                >
                  If you would like to continue, please mark the following
                  checkbox and fill the text field:
                </Box>
              </Typography>
            ) : (
              <Typography>
                Are you sure you want to reactivate this website?
                <br />
                Reactivating the website will make it accessible to all
                authorized users
                <br />
                <Box
                  component="span"
                  sx={{ display: "block", fontWeight: 500, marginTop: "8px" }}
                >
                  If you would like to continue, please mark the following
                  checkbox and fill the text field:
                </Box>
              </Typography>
            )}

            <Box mt={1} mx={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isDeactivate}
                    onChange={(e) =>
                      setisDeactivate(e.target.checked ? true : false)
                    }
                    color="secondary"
                  />
                }
                label={
                  isActive
                    ? "I would like to deactivate the website"
                    : "I would like to activate the website "
                }
              />
            </Box>
            <Box mt={1}>
              <TextField
                id="outlined-multiline-flexible"
                label="Website Name" // Set your label here
                placeholder="How you like the site to be called" // Set your placeholder here
                required
                value={siteName}
                onChange={(e) => setSiteName(e.target.value)}
                fullWidth
                color="secondary"
                size="small"
              />
              <Typography
                sx={{ marginTop: "4px", fontSize: "12px", color: "#00000099" }}
              >
                As it is written in the edit website screen
              </Typography>
            </Box>
          </Box>
          <Stack
            flexDirection={"row"}
            justifyContent={"end"}
            marginTop={2}
            gap={1}
          >
            <Button color="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={deactiveOrActiveWebsite}
              disabled={
                !isDeactivate ||
                siteName !== website_name ||
                !hasToggleWebsiteStatusPermission
              }
            >
              <Stack flexDirection={"row"} gap={1}>
                {isActive === 1 ? "deactivate" : "activate"}
              </Stack>
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
}

export default DeORReactivateWebsiteModal;
